var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_9511_20883)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9511_20883",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9511_20883",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9511_20883",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACnElEQVR4nO2dzU4CMRSFz4PIUmYvi/GJTUTUp/JnoTLwAtc0KRujZkroPbfT8yXdAIHO+aAztJcCCCGEEG1xBeAOwBuAA4BHAGt2p3phBPAFwH60fb5PVGTzR/inNgG4ZXey1/BNEvjhmyTwwzdJ4IdvksAP3ySBH75JQjljDqwk3LmP0/eECu/8GwCf+iTwhp1E9xJWAHYAjhcct61AwDlD17ktHeMzgAGBwp/77qspwFOC5U9rOnY6O2L49kt/PCVsEYBjMAGeEtJUOB0LKKD0xFzj9dG7AC8JdCILOA1HabFGAogBrPOyZRqzJaCxAEwCIAH/IQFkJICMBJCRADISQEYCyEgAGQkgkuZZehcwYiGlI9aoAMoas+eqk5EFHKOVvEQK3xyO93FmP1wkRAvfah9wnsreR5AQZcw3ZwEh6o6ihm/wgyYhcvgGX9wlRA/f4I+bhBbCN3CoLqGV8A08qkkYKpdxLEVA6WX5fu6PyR8ChGqNCCiVMKuW9C1AqNaQgJLh6H3Ok70GCNUaEzD3nPky58m2AUK1noegkrmPCG1xJ2HP0m5rWEDJpfpZk3StSFhk+C1JWGz4rUhYdPgtSFh8+NEldBF+z0uSQ5QlyagSavMUKfyIErorS4l2TqhNyPBPqDQR/D2IehdARwLISAAZCSAjAWQkgIwEkJEAMhJARgLItCBgyLOaNTYYpBNdwKgty3gCNg5V3nSiCtg4ldjT6Xnj1gkBeA4mYHRcrbtHAAbyr2lY4X/kf/QLwSpX/h6IAkbH/aLvI4XPXmMOVbfTo4SNwr8so/7Eh8/NhUteFD5RwqTweRImhc+TMCl8noRJ4fMkTAqfJ2FS+PUZ/1hgSbcpfCfWeVOR19zSPNQ1u1NCCCEECvgGgBRnl/b2L8sAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.32efb84f8d8632b126fc8edf1face8ae.svg";
export { ForwardRef as ReactComponent };